import type {
  CognitoUser,
  CognitoUserSession,
} from "amazon-cognito-identity-js";
import { Auth } from "aws-amplify";

class LoginService {
  async signIn(id: string, pw: string): Promise<UserToken> {
    const cognitoUser: CognitoUser = await Auth.signIn(id, pw);
    const idToken = cognitoUser.getSignInUserSession()?.getIdToken();
    const refreshToken = cognitoUser.getSignInUserSession()?.getRefreshToken();
    if (idToken === undefined || refreshToken === undefined) {
      throw new Error("Cognito auth error.");
    }
    return new Promise((resolve) => {
      const userToken: UserToken = {
        id: id,
        idToken: idToken.getJwtToken(),
        idTokenExp: idToken.getExpiration(),
        refreshToken: refreshToken.getToken(),
      };
      resolve(userToken);
    });
  }

  async updateSession(): Promise<UserToken> {
    const cognitoUser: CognitoUser = await Auth.currentAuthenticatedUser();
    const currentSession: CognitoUserSession = await Auth.currentSession();
    const refreshToken = currentSession.getRefreshToken();
    return await new Promise((resolve, reject) => {
      cognitoUser.refreshSession(refreshToken, (err, session) => {
        if (err) {
          console.log("update session error.");
          reject(new Error(err));
        } else {
          const currentSession: UserToken = {
            id: session.getAccessToken().payload.username,
            idToken: session.getIdToken().getJwtToken(),
            idTokenExp: session.getIdToken().getExpiration(),
            refreshToken: session.getRefreshToken().getToken(),
          };
          resolve(currentSession);
        }
      });
    });
  }

  async signOut(): Promise<any> {
    try {
      await Auth.signOut();
    } catch(err: any) {
      console.log("SignOut error.");
      throw new Error(err);
    }
  }
}

export interface UserToken {
  id: string;
  idToken: string;
  idTokenExp: number;
  refreshToken: string;
}

export const loginService = new LoginService();
